import ScoringType from './ScoringType.js';

// @see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/enum/pitch-call-result-statgrab.json
// @see also https://docs.google.com/document/d/1Tzpf6Z0tahdFu27C_QiIi02eAnVv4zA7S1VMS-UCbCs/edit#bookmark=id.kwe337nc4hzj
const PitchCall = {
    Ball: { key: 'B', name: 'Ball' },
    CalledStrike: { key: 'CS', name: 'Called Strike' },
    SwingingStrike: { key: 'SS', name: 'Swing & Miss' },
    IntentionalBall: { key: 'IB', name: 'Intentional Ball' },
    FoulBall: { key: 'FB', name: 'Foul Ball' },
    PitchOut: { key: 'PO', name: 'Pitchout' },
    FoulTip: { key: 'FT', name: 'Foul Tip' },
    FoulBunt: {key: 'BF', name: 'Foul Bunt' },
    HitByPitch: { key: 'HP', name: 'Hit By Pitch' },
    NoPitch: { key: 'NP', name: 'No Pitch' },
    Balk: { key: 'BK', name: 'Balk' },
    IllegalPitch: { key: 'IP', name: 'Illegal Pitch' },
    BallInPlay: { key: 'BP', name: 'Ball In Play' },
    Unidentified: { key: 'UI', name: 'Unidentified' },
};

const PitchCallPerScoringType = {
    [ScoringType.StatGrab.key]: PitchCall,
    [ScoringType.extendedTagging.key]: {
        // note, PITCH_CALL for extended tagging is a bit limited compared to default StatGrab set
        // see https://docs.google.com/spreadsheets/d/1epxNaZ5vb5523jMQ9Q4mgjbUb-M6w6wALANRcL5gAlY/edit#gid=1286954846&range=A25:A38
        // see https://bitbucket.org/flightscope/dto-schema/src/master/baseball/enum/pitch-call-result-extended-tagging.json
        Ball: PitchCall.Ball,
        CalledStrike: PitchCall.CalledStrike,
        SwingingStrike: PitchCall.SwingingStrike,
        IntentionalBall: PitchCall.IntentionalBall,
        FoulBall: PitchCall.FoulBall,
        // PitchOut removed
        FoulTip: PitchCall.FoulTip,
        // FoulBunt removed
        HitByPitch: PitchCall.HitByPitch,
        // NoPitch removed
        Balk: PitchCall.Balk,
        IllegalPitch: PitchCall.IllegalPitch,
        BallInPlay: PitchCall.BallInPlay,
        Unidentified: PitchCall.Unidentified,
    },
};

export default PitchCall;
export {
    PitchCall,
    PitchCallPerScoringType
};